<template>
  <div class="main-start">
    <h4>
      <i class="el-icon-sort-down"></i>
      メイン 開始
    </h4>
  </div>
</template>

<script>
export default {
  name: "MainStart",
  props: {
    act: Object
  }
};
</script>
